/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Zusammenarbeitstringfordetails4Inputs */

const de__field_zusammenarbeitstringfordetails4 = /** @type {(inputs: _Field_Zusammenarbeitstringfordetails4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitgliedschaft`)
};

/**

* @param {_Field_Zusammenarbeitstringfordetails4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_zusammenarbeitstringfordetails4 = /** @type {((inputs?: _Field_Zusammenarbeitstringfordetails4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Zusammenarbeitstringfordetails4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_zusammenarbeitstringfordetails4(inputs)
});
export { _field_zusammenarbeitstringfordetails4 as "_field_zusammenArbeitStringForDetails" }